module.exports = __webpack_public_path__ + "static/media/LiveClassesEducation2.d307d2c5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClass/LiveClassesEducation2.webp
// module id = 870
// module chunks = 7